export const CATEGORY_ALL = 'All';
export const CATEGORIES_DEFAULT = [CATEGORY_ALL];
